/**
 * PDP recommendations — fetches full collection catalog via products.json
 * (Liquid collection.products is capped on product templates).
 */
(function () {
  function parseConfig(section) {
    return {
      role: section.getAttribute("data-lb-rec"),
      collection: section.getAttribute("data-collection") || "",
      vendor: section.getAttribute("data-vendor") || "",
      family: section.getAttribute("data-family") || "",
      productId: String(section.getAttribute("data-product-id") || ""),
      limit: parseInt(section.getAttribute("data-limit") || "6", 10) || 6,
      grid: section.querySelector("[data-lb-rec-grid]"),
      status: section.querySelector("[data-lb-rec-status]"),
      section: section,
    };
  }

  function titleFamily(title, family) {
    var t = (title || "").toLowerCase();
    if (!family) return true;
    if (family === "tea") return t.indexOf("tea") !== -1;
    if (family === "coffee") {
      return t.indexOf("coffee") !== -1 || t.indexOf("espresso") !== -1;
    }
    if (family === "crisps") {
      return t.indexOf("crisp") !== -1 || t.indexOf("chip") !== -1;
    }
    if (family === "biscuits") {
      return (
        t.indexOf("biscuit") !== -1 ||
        t.indexOf("cookie") !== -1 ||
        t.indexOf("digestive") !== -1
      );
    }
    return true;
  }

  function vendorMatch(productVendor, targetVendor) {
    return (
      String(productVendor || "").trim().toLowerCase() ===
      String(targetVendor || "").trim().toLowerCase()
    );
  }

  function scoreProduct(product, cfg, tier) {
    if (String(product.id) === cfg.productId) return -1;
    if (!titleFamily(product.title, cfg.family)) return -1;

    if (tier === 1 && cfg.vendor && vendorMatch(product.vendor, cfg.vendor)) {
      return 300;
    }
    if (tier === 2 && cfg.family) return 200;
    if (tier === 3) return 100;
    return -1;
  }

  function pickProducts(products, cfg, seen) {
    var ranked = [];

    [1, 2, 3].forEach(function (tier) {
      products.forEach(function (product) {
        if (seen[product.id]) return;
        var score = scoreProduct(product, cfg, tier);
        if (score < 0) return;
        ranked.push({ product: product, score: score });
      });
    });

    ranked.sort(function (a, b) {
      return b.score - a.score;
    });

    var picks = [];
    ranked.some(function (row) {
      if (picks.length >= cfg.limit) return true;
      if (seen[row.product.id]) return false;
      seen[row.product.id] = true;
      picks.push(row.product);
      return false;
    });
    return picks;
  }

  function fetchCollectionProducts(handle) {
    var all = [];
    var page = 1;

    function next() {
      if (page > 6) return Promise.resolve(all);
      return fetch(
        "/collections/" +
          encodeURIComponent(handle) +
          "/products.json?limit=250&page=" +
          page
      )
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var batch = (data && data.products) || [];
          if (!batch.length) return all;
          all = all.concat(batch);
          page += 1;
          return next();
        })
        .catch(function () {
          return all;
        });
    }

    return next();
  }

  function formatMoney(amount) {
    var n = parseFloat(amount);
    if (isNaN(n)) return "";
    return "$" + n.toFixed(2);
  }

  function productCard(product) {
    var image = product.images && product.images[0];
    var variant = product.variants && product.variants[0];
    var price = variant ? variant.price : product.price;
    var item = document.createElement("div");
    item.className = "lb-product-grid__item";
    item.innerHTML =
      '<article class="lb-product-card lb-product-card--single-unit" data-product-card>' +
      '<a href="/products/' +
      encodeURIComponent(product.handle) +
      '" class="lb-product-card__media">' +
      (image
        ? '<div class="lb-product-card__img"><img src="' +
          image.src +
          '" alt="' +
          (image.alt || product.title).replace(/"/g, "&quot;") +
          '" loading="lazy" width="400" height="400"></div>'
        : "") +
      "</a>" +
      '<div class="lb-product-card__body">' +
      '<a href="/products/' +
      encodeURIComponent(product.handle) +
      '" class="lb-product-card__info">' +
      '<h3 class="lb-product-card__title">' +
      product.title +
      "</h3>" +
      "</a>" +
      (price
        ? '<p class="lb-product-card__price"><span class="lb-price">' +
          formatMoney(price) +
          "</span></p>"
        : "") +
      "</div></article>";
    return item;
  }

  function renderSection(cfg, products) {
    if (!cfg.grid) return;
    cfg.grid.innerHTML = "";
    products.forEach(function (product) {
      cfg.grid.appendChild(productCard(product));
    });
    if (cfg.status) cfg.status.hidden = products.length > 0;
    cfg.section.hidden = products.length === 0;
  }

  function init() {
    var sections = Array.prototype.slice.call(
      document.querySelectorAll("[data-lb-rec-section]")
    );
    if (!sections.length) return;

    var configs = sections.map(parseConfig);
    var collection = configs[0].collection;
    if (!collection) return;

    configs.forEach(function (cfg) {
      if (cfg.status) cfg.status.textContent = "Loading recommendations…";
    });

    fetchCollectionProducts(collection).then(function (products) {
      var seen = {};
      if (configs[0].productId) seen[configs[0].productId] = true;

      configs.forEach(function (cfg) {
        var picks = pickProducts(products, cfg, seen);
        renderSection(cfg, picks);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
